import React from 'react';
import { toast } from 'react-toastify';

import { ReactComponent as ToastDefaultIcon } from '../../../assets/icons/toast_success_icon.svg';
import { ReactComponent as ToastIconError } from '../../../assets/icons/toast_error_icon.svg';
import { ReactComponent as ToastIconWarning } from '../../../assets/icons/toast_warning_icon.svg';

export const successToastMessage = (message) => {
  return toast.success(message, {
    icon: <ToastDefaultIcon />,
    closeButton: true,
    autoClose: 3000,
  });
};

export const errorToastMessage = (message) => {
  return toast.error(message, {
    icon: <ToastIconError />,
    autoClose: false,
    closeOnClick: true,
  });
};

export const warningToastMessage = (message) => {
  return toast.warning(message, {
    icon: <ToastIconWarning />,
    closeButton: false,
  });
};
